import { render, staticRenderFns } from "./SituacionLaboralCrud.vue?vue&type=template&id=78e410c4"
import script from "./SituacionLaboralCrud.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports